// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"32aa9e7a","96":"96fef82f","215":"48f5d748","334":"bef550cf","391":"9462f7e1","598":"b4ccfe3f","639":"912de0c7","688":"0b633ccc","960":"32aa9e7a"}[chunkId] + ".chunk.css";
};